import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/UnAutorized.png'


const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "information_image_size",
  alt: "Imagen",
  src: _imports_0
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}